module.exports = __webpack_public_path__ + "static/unity-a0bb06ca786ecf6328eb54095729f36e.png";